import { createSelector } from 'reselect';
import { get } from 'lodash';
import { JourneyConfigState, RootState } from '../state';
import { JOURNEY_CHAT_ENABLE } from '../../customization/constants';

export const selectJourneyConfigState = (state: RootState) => state?.journey?.config

export const selectJourneyConfig = createSelector(
  selectJourneyConfigState,
  (state: JourneyConfigState) => state?.data
);

export const selectJourneyConfigLoading = createSelector(
  selectJourneyConfigState,
  (state: JourneyConfigState) => state?.isLoading
);
export const selectJourneyConfigLoaded = createSelector(
  selectJourneyConfigState,
  (state: JourneyConfigState) => state?.loaded
);

export const selectJourneyConfigChatEnabled = createSelector(
  selectJourneyConfigState,
  (state: JourneyConfigState) => get(state?.data, JOURNEY_CHAT_ENABLE, false)
);
